export const getPharmacyWholesalerList = (item,pharmacyMedicineId) => {
    let result = []
    //個別に設定がある場合はそちらを優先する
    for (let i=0;i<item.pharmacy_medicine_list.length;i++) {
      if (item.pharmacy_medicine_list[i].id == pharmacyMedicineId) {
        if (item.pharmacy_medicine_list[i].wholesalers.length > 0) {
          result = item.pharmacy_medicine_list[i].wholesalers;
        }
        break;
      }
    }

    if (result.length == 0) {
        result = item.pharmacy_wholesaler_list;
    }
    return result;
}
export const getHeadMedicineMark = () => {
  return '<span class="head-medicine-mark">本部管理品</span>';
}
